import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=23872905&"
import script from "./cmp.vue?vue&type=script&lang=js&"
export * from "./cmp.vue?vue&type=script&lang=js&"
import style0 from "./cmp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports